import * as React from 'react';
import { useState, useEffect } from 'react';
import { Box, IconButton, Typography, Tooltip } from '@mui/material';
import { Table, TableContainer, TableRow, TableBody, TableHead, TableCell } from '@mui/material';
import usersEndpoints from '../../../services/userServices';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';

// function createData(invoiceId, transactionDate, transactionStatus, amount, prevCredits, updatedCredits){
//     return { invoiceId, transactionDate, transactionStatus, amount, prevCredits, updatedCredits };
// }

// const rows = [
//     createData('wGKLVZmuPf', '01-05-2022', 'success', 3000, 40, 3040),
//     createData('iihek0I-Hc', '02-05-2022', 'success', 500, 2700, 3200),
//     createData('LQkBr3pLhG', '03-05-2022', 'failed', 5000, 1020, 1020),
//     createData('MDNoTh7Q3K', '04-05-2022', 'success', 1200, 40, 1240),
//     createData('U7Xp3-75YM', '05-05-2022', 'failed', 3000, 350, 350),
//     createData('LQkBr3pLhG', '03-05-2022', 'failed', 5000, 1020, 1020),
//     createData('MDNoTh7Q3K', '04-05-2022', 'success', 1200, 40, 1240),
//     createData('U7Xp3-75YM', '05-05-2022', 'failed', 3000, 350, 350),
//     createData('LQkBr3pLhG', '03-05-2022', 'failed', 5000, 1020, 1020),
//     createData('MDNoTh7Q3K', '04-05-2022', 'success', 1200, 40, 1240),
//     createData('U7Xp3-75YM', '05-05-2022', 'failed', 3000, 350, 350)
// ];

function UserInvoicesList(){
    const [transactionList, setTransactionList] = useState([]);

    useEffect(async () => {
        const response = await usersEndpoints.fetchBillingDetails();
        if(response['success'] === true){
            setTransactionList(response['data']);
        }
    }, []);

    const downloadInvoice = (transaction) => {
        window.open(`/billing/invoice/${ btoa(transaction.invoiceId) }`, '_blank');
    }

    return (
        <>
            {/* <Box 
                component={ "div" }
                sx={{ marginBottom: 2 }}
            >
                <Typography 
                    variant={ 'h6' }
                    sx={{ fontWeight: '600' }}
                >
                    Your Transactions
                </Typography>
            </Box> */}
            <TableContainer
                sx={{
                    maxHeight: '60vh',
                    border: '1px solid #F3F4F6',
                    borderRadius: '12px',
                    '& .MuiTableCell-head': {
                        bgcolor: '#F9FAFB',
                        color: '#6B7280',
                        fontSize: 12,
                        fontWeight: 700,
                        textTransform: 'uppercase',
                        letterSpacing: '0.04em',
                        borderBottom: '1px solid #F3F4F6',
                        whiteSpace: 'nowrap',
                    },
                    '& .MuiTableCell-body': {
                        fontSize: 13.5,
                        color: '#111827',
                        borderBottom: '1px solid #F3F4F6',
                    },
                    '& .MuiTableBody-root .MuiTableRow-root:last-of-type .MuiTableCell-body': {
                        borderBottom: 'none',
                    },
                }}
            >
                <Table stickyHeader>
                    <TableHead>
                        <TableRow>
                            {/* <TableCell>Transaction ID</TableCell> */}
                            <TableCell align='center'>Transaction Date</TableCell>
                            <TableCell align='center'>Status</TableCell>
                            <TableCell align='center'>Amount</TableCell>
                            <TableCell align='center'>Previous Credits</TableCell>
                            <TableCell align='center'>Final Credits</TableCell>
                            <TableCell align='center'>Invoice</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                            transactionList.length > 0 ?
                            transactionList.map((transaction, index) => {
                                const isSuccess = transaction.transactionStatus.toLowerCase() === "captured";
                                return (
                                    <TableRow
                                        key={ `transaction-row-${ index }` }
                                        hover
                                    >
                                        {/* <TableCell>{ transaction.invoiceId }</TableCell> */}
                                        <TableCell align='center'>{ transaction.transactionDate }</TableCell>
                                        <TableCell align='center'>
                                            <Box
                                                component="span"
                                                sx={{
                                                    display: 'inline-block',
                                                    px: 1.25,
                                                    py: 0.25,
                                                    borderRadius: '999px',
                                                    fontSize: 12,
                                                    fontWeight: 700,
                                                    textTransform: 'capitalize',
                                                    color: isSuccess ? '#067A24' : '#B42318',
                                                    bgcolor: isSuccess ? 'rgba(9,172,49,0.1)' : 'rgba(227,76,20,0.1)',
                                                }}
                                            >
                                                { isSuccess ? "successful" : transaction.transactionStatus.toLowerCase() }
                                            </Box>
                                        </TableCell>
                                        <TableCell align='center' sx={{ fontWeight: 600 }}>{ transaction.amount }</TableCell>
                                        <TableCell align='center'>{ transaction.prevCredits }</TableCell>
                                        <TableCell align='center'>{ transaction.updatedCredits }</TableCell>
                                        <TableCell align='center'>
                                            <Tooltip title={ isSuccess ? "Download invoice" : "Invoice unavailable" } arrow>
                                                <span>
                                                    <IconButton
                                                        size="small"
                                                        disabled={ !isSuccess }
                                                        onClick={ () => downloadInvoice(transaction) }
                                                        sx={{
                                                            color: '#FF5200',
                                                            bgcolor: 'rgba(255,82,0,0.08)',
                                                            borderRadius: '8px',
                                                            '&:hover': { bgcolor: 'rgba(255,82,0,0.16)' },
                                                        }}
                                                    >
                                                        <FileDownloadOutlinedIcon fontSize="small" />
                                                    </IconButton>
                                                </span>
                                            </Tooltip>
                                        </TableCell>
                                    </TableRow>
                                );
                            })
                            :
                            <TableRow>
                                <TableCell colSpan={6} sx={{ py: 6 }}>
                                    <Typography sx={{ textAlign: 'center', fontWeight: 700, mb: 0.5 }}>
                                        No transactions yet
                                    </Typography>
                                    <Typography sx={{ textAlign: 'center', color: '#6B7280', fontSize: 13.5 }}>
                                        Your credit purchases and invoices will appear here.
                                    </Typography>
                                </TableCell>
                            </TableRow>
                        }
                    </TableBody>
                </Table>
            </TableContainer>
        </>
    );
}

export default UserInvoicesList;